import React from 'react';
import Page from './Page';
import { Router, Route, browserHistory } from 'react-router';

require('../styles/App.css');

class AppComponent extends React.Component {
  render() {
    return (
      <Router history={browserHistory}>
        <Route path="/" component={Page} />
        <Route path="/train/" component={Page} />
        <Route path="/train/:trainNumber/" component={Page} />
        <Route path="/route/" component={Page} />
        <Route path="/route/:routeFrom/" component={Page} />
        <Route path="/route//:routeTo/" component={Page} />
        <Route path="/route/:routeFrom/:routeTo/" component={Page} />
      </Router>
    );
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;



/** WEBPACK FOOTER **
 ** ./src/components/Main.js
 **/